import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
});

/**
 * Category reducer to manage category's state globaly in app
 * @param {*} state category state
 * @param {*} action category action
 */
export function categoryReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CATEGORIES:
      return {
        ...state,
        byId: {},
      };
    case actionTypes.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
      };
    // return state.merge({
    //   params: action.payload.params || {},
    //   byId: action.payload.byId || {},
    // });
    default:
      return state;
  }
}
